export class JwtData {
  constructor(data: jwtTokenData) {
    this.jti=data.jti;
    this.sub=data.sub;
    this.email=data.email;
    this.name=data.name;
    this.role=data["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    this.exp=data.exp;
    this.iss=data.iss;
    this.aud=data.aud;
  }
  jti: string;
  sub: string;
  email: string;
  name: string;
  uid: string;
  role: string;
  exp: number;
  iss: string;
  aud: string;
}

interface jwtTokenData {
  jti: string;
  sub: string;
  email: string;
  name: string;
  uid: string;
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string;
  exp: number;
  iss: string;
  aud: string;
}
